import React, { useState } from "react";
import "./Details.scss";
// import Logo from '../../img/Logo.svg'
// import { FaAngleLeft } from "react-icons/fa";
// import { useNavigate } from 'react-router-dom';
// import { useParams } from 'react-router-dom';

const Details = () => {
  // const [CategoryData,setCategoryData] = useState([])
  // const { name } = useParams();
  // const { item } = useParams();
  // const abc = item

  // console.log(name,item)

  // const navigate = useNavigate();
  // const handleGoBack = () => {
  //   navigate(-1); // Navigate back to the previous page
  // };

  // console.log(CategoryData)

  // const categoryWiseData = CategoryData && CategoryData.find((item) => item.Name === name)
  // const findItem = categoryWiseData && categoryWiseData?.type.map((item) => item)
  // const findItemname = findItem && findItem.find((item) => item.Name === abc)

  


  return (
    <div id="categoryPage">
      {/* <div className="headerSections">
        <img width={97} src={Logo} alt="Cjs" />
        <div style={{paddingBottom:"1rem"}}></div>
        <div className="chooseCategory">
           <span onClick={handleGoBack} style={{position:"absolute",left:"10px",display:"flex",alignItems:"center",alignContent:"center",gap:"2px"}}> 
              <span style={{paddingTop:"4px"}}><FaAngleLeft/></span>
              <span style={{textTransform:"inherit",fontSize:"12px"}}>Go back</span>
            </span>
           <span style={{textTransform:"uppercase",fontWeight:"700"}}>{item}</span>
        </div>
      </div>

   <div className="marginDetails">
   <div className="box-item-detailspage" style={{display:"grid",
        gap:"10px"
      }}>
          <span style={{marginTop:"7px"}}>
             <img style={{width:"95%",borderRadius:"10px"}} src={findItemname.ImageURL} alt="Details" />
          </span>

          <div style={{margin:"auto",display:"block",width:"92%"}}>
            <div style={{display:"grid",textAlign:"left",gap:"10px"}}>
            <span className="name">{findItemname.Name}</span>
            <spa className="dec">{findItemname.dec}</spa>
            <span className="kes">{findItemname.KES} KES</span>
            </div>

          </div>
      </div>
   </div>
     */}

     

    

   
    </div>
  );
};

export default Details;
